import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var Parse = require("parse");

/**
 * Contains functions for calling and declaring
 *
 * @class Jobin.Client
 * @static
 * @hideconstructor
 */

/**
 * Create a new client with no verification needed
 * @method createClient
 * @name Jobin.Client.createClient
 * @param {string} name
 * @param {string} phone
 * @param {string} [email]
 * @returns {ParseObject} New user.
 */
export function createClient(_x, _x2, _x3) {
  return _createClient.apply(this, arguments);
}
/**
 * Get a user by phone
 * @method getClientByPhone
 * @name Jobin.Client.getClientByPhone
 * @param {string} phone
 * @returns {ParseObject} User.
 */
function _createClient() {
  _createClient = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(name, phone, email) {
    var result, query;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return Parse.Cloud.run("createUser", {
            phone: phone,
            username: name,
            userEmail: email
          });
        case 3:
          result = _context.sent;
          query = new Parse.Query(Parse.User);
          query.equalTo("objectId", result);
          _context.prev = 6;
          _context.next = 9;
          return query.first();
        case 9:
          _context.t0 = _context.sent;
          return _context.abrupt("return", {
            status: "ok",
            result: _context.t0
          });
        case 13:
          _context.prev = 13;
          _context.t1 = _context["catch"](6);
          return _context.abrupt("return", {
            status: "error",
            result: "Error al registrar el nuevo usuario."
          });
        case 16:
          _context.next = 22;
          break;
        case 18:
          _context.prev = 18;
          _context.t2 = _context["catch"](0);
          console.error(_context.t2);
          return _context.abrupt("return", {
            status: "error",
            result: "Error al registrar el nuevo usuario."
          });
        case 22:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 18], [6, 13]]);
  }));
  return _createClient.apply(this, arguments);
}
export function getClientByPhone(_x4) {
  return _getClientByPhone.apply(this, arguments);
}
/**
 * Send SMS to phoneNumber to init log in or register
 * @method sendSMSCode
 * @name Jobin.Client.sendSMSCode
 * @param {string} phoneNumber - The user Phone Number.
 * @param {string} email - The user email.
 * @param {string} name - The user name.
 * @param {boolean} fromMaster - If true, no SMS will send.
 * @returns {ParseObject} The user that matches with the phone.
 */
function _getClientByPhone() {
  _getClientByPhone = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(phone) {
    var user;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return new Parse.Query(Parse.User).equalTo("Phone", phone).first();
        case 3:
          user = _context2.sent;
          if (user) {
            _context2.next = 8;
            break;
          }
          return _context2.abrupt("return", {
            status: "ok",
            result: undefined
          });
        case 8:
          if (!user.get("Jober")) {
            _context2.next = 12;
            break;
          }
          return _context2.abrupt("return", {
            status: "error",
            result: "Parece que este número de teléfono ya está vinculado a una cuenta de Jobin Pro"
          });
        case 12:
          return _context2.abrupt("return", {
            status: "ok",
            result: user
          });
        case 13:
          _context2.next = 19;
          break;
        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](0);
          console.error(_context2.t0);
          return _context2.abrupt("return", {
            status: "error",
            result: _context2.t0
          });
        case 19:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 15]]);
  }));
  return _getClientByPhone.apply(this, arguments);
}
export function sendSMSCode(_x5, _x6, _x7, _x8, _x9) {
  return _sendSMSCode.apply(this, arguments);
}
/**
 * Use it to verify if the phone number and the code matches
 * @method verifySMSCode
 * @name Jobin.Client.verifySMSCode
 * @param {string} phoneNumber - The user Phone Number.
 * @param {string} code - The secret code that the user recibed.
 * @param {ParseObject} user - The user recibed in sendSMSCode().
 * @returns {boolean} If true, is a sign up.
 */
function _sendSMSCode() {
  _sendSMSCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(phoneNumber, fromMaster, isPelayo, email, name) {
    var phone1, phone2, phone3, User, query, user, isJober, emailQuery, result, userId, _User, queryRegisterUser, newUser;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!phoneNumber) {
            _context3.next = 118;
            break;
          }
          //Create the diferent phones
          phone1 = phoneNumber.substring(2, phoneNumber.lenght);
          phone2 = phoneNumber.substring(3, phoneNumber.lenght);
          phone3 = phoneNumber.substring(4, phoneNumber.lenght); //Search a user with this phone number
          User = Parse.Object.extend("_User");
          query = new Parse.Query(User);
          query.containedIn("Phone", [phone1, phone2, phone3, phoneNumber]);
          query.select("username", "Active");
          _context3.prev = 8;
          _context3.next = 11;
          return query.first();
        case 11:
          user = _context3.sent;
          if (!user) {
            _context3.next = 86;
            break;
          }
          isJober = user.get("Jober");
          if (!isJober) {
            _context3.next = 18;
            break;
          }
          return _context3.abrupt("return", {
            status: "error",
            result: "Parece que este número de teléfono ya está vinculado a una cuenta de Jobin Pro"
          });
        case 18:
          if (!email) {
            _context3.next = 74;
            break;
          }
          if (!(user.email === email)) {
            _context3.next = 32;
            break;
          }
          _context3.prev = 20;
          _context3.next = 23;
          return Parse.Cloud.run("logInUser", {
            userId: user.id,
            phone: phoneNumber,
            fromMaster: fromMaster,
            isPelayo: isPelayo
          });
        case 23:
          return _context3.abrupt("return", {
            status: "ok",
            result: user
          });
        case 26:
          _context3.prev = 26;
          _context3.t0 = _context3["catch"](20);
          console.error(_context3.t0);
          return _context3.abrupt("return", {
            status: "error",
            result: _context3.t0
          });
        case 30:
          _context3.next = 72;
          break;
        case 32:
          //Search if other user have this email
          emailQuery = new Parse.Query("_User");
          emailQuery.equalTo("email", email);
          emailQuery.notEqualTo("objectId", user.id);
          _context3.prev = 35;
          _context3.next = 38;
          return emailQuery.first();
        case 38:
          result = _context3.sent;
          if (!result) {
            _context3.next = 52;
            break;
          }
          _context3.prev = 40;
          _context3.next = 43;
          return Parse.Cloud.run("logInUser", {
            userId: user.id,
            phone: phoneNumber,
            fromMaster: fromMaster,
            isPelayo: isPelayo
          });
        case 43:
          return _context3.abrupt("return", {
            status: "ok",
            result: user
          });
        case 46:
          _context3.prev = 46;
          _context3.t1 = _context3["catch"](40);
          console.error(_context3.t1);
          return _context3.abrupt("return", {
            status: "error",
            result: _context3.t1
          });
        case 50:
          _context3.next = 66;
          break;
        case 52:
          //Update user email
          user.set("email", email);
          user.set("Name", name);
          _context3.next = 56;
          return user.save();
        case 56:
          _context3.prev = 56;
          _context3.next = 59;
          return Parse.Cloud.run("logInUser", {
            userId: user.id,
            phone: phoneNumber,
            fromMaster: fromMaster,
            isPelayo: isPelayo
          });
        case 59:
          return _context3.abrupt("return", {
            status: "ok",
            result: user
          });
        case 62:
          _context3.prev = 62;
          _context3.t2 = _context3["catch"](56);
          console.error(_context3.t2);
          return _context3.abrupt("return", {
            status: "error",
            result: _context3.t2
          });
        case 66:
          _context3.next = 72;
          break;
        case 68:
          _context3.prev = 68;
          _context3.t3 = _context3["catch"](35);
          console.error(_context3.t3);
          return _context3.abrupt("return", {
            status: "error",
            result: _context3.t3
          });
        case 72:
          _context3.next = 84;
          break;
        case 74:
          _context3.prev = 74;
          _context3.next = 77;
          return Parse.Cloud.run("logInUser", {
            userId: user.id,
            phone: phoneNumber,
            fromMaster: fromMaster,
            isPelayo: isPelayo
          });
        case 77:
          return _context3.abrupt("return", {
            status: "ok",
            result: user
          });
        case 80:
          _context3.prev = 80;
          _context3.t4 = _context3["catch"](74);
          console.error(_context3.t4);
          return _context3.abrupt("return", {
            status: "error",
            result: _context3.t4
          });
        case 84:
          _context3.next = 110;
          break;
        case 86:
          _context3.prev = 86;
          _context3.next = 89;
          return Parse.Cloud.run("registerUser", {
            phone: phoneNumber,
            fromMaster: fromMaster,
            acceptTerms: true,
            name: name,
            email: email,
            jober: false
          });
        case 89:
          userId = _context3.sent;
          _User = Parse.Object.extend("_User");
          queryRegisterUser = new Parse.Query(_User);
          queryRegisterUser.equalTo("objectId", userId);
          _context3.prev = 93;
          _context3.next = 96;
          return queryRegisterUser.first();
        case 96:
          newUser = _context3.sent;
          return _context3.abrupt("return", {
            status: "ok",
            result: newUser
          });
        case 100:
          _context3.prev = 100;
          _context3.t5 = _context3["catch"](93);
          console.error(_context3.t5);
          return _context3.abrupt("return", {
            status: "error",
            result: _context3.t5
          });
        case 104:
          _context3.next = 110;
          break;
        case 106:
          _context3.prev = 106;
          _context3.t6 = _context3["catch"](86);
          console.error(_context3.t6);
          return _context3.abrupt("return", {
            status: "error",
            result: "Parece que este email ya está vinculado con otra cuenta. Debes utilizar otro."
          });
        case 110:
          _context3.next = 116;
          break;
        case 112:
          _context3.prev = 112;
          _context3.t7 = _context3["catch"](8);
          console.error(_context3.t7);
          return _context3.abrupt("return", {
            status: "error",
            result: _context3.t7
          });
        case 116:
          _context3.next = 120;
          break;
        case 118:
          console.error("Falta parametro phoneNumber");
          return _context3.abrupt("return", {
            status: "error",
            result: "Falta parametro phoneNumber"
          });
        case 120:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[8, 112], [20, 26], [35, 68], [40, 46], [56, 62], [74, 80], [86, 106], [93, 100]]);
  }));
  return _sendSMSCode.apply(this, arguments);
}
export function verifySMSCode(_x10, _x11, _x12) {
  return _verifySMSCode.apply(this, arguments);
}
/**
 * User accept Terms of Service updates.
 * @method updateTerms
 * @name Jobin.Client.updateTerms
 * @returns {boolean} Success.
 */
function _verifySMSCode() {
  _verifySMSCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(code, phoneNumber, user) {
    var username, loggedUser, phone, isActive, currentSession, currentUser;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          username = user.get("username");
          _context4.prev = 1;
          _context4.next = 4;
          return Parse.User.logIn(username, code);
        case 4:
          loggedUser = _context4.sent;
          phone = loggedUser.get("Phone");
          if (!phone) {
            _context4.next = 19;
            break;
          }
          //Is a loggin
          isActive = loggedUser.get("Active");
          if (!isActive) {
            _context4.next = 16;
            break;
          }
          _context4.next = 11;
          return Parse.Session.current();
        case 11:
          currentSession = _context4.sent;
          currentSession.get("installationId");
          return _context4.abrupt("return", {
            status: "ok",
            result: false
          });
        case 16:
          return _context4.abrupt("return", {
            status: "error",
            result: "Parece que tu cuenta ha sido bloqueada por incumplimiento de los términos y condiciones de uso. Puedes llamarnos y te explicaremos los motivos."
          });
        case 17:
          _context4.next = 36;
          break;
        case 19:
          _context4.next = 21;
          return Parse.User.currentAsync();
        case 21:
          currentUser = _context4.sent;
          currentUser.set("Phone", phoneNumber);
          currentUser.set("Jober", false);
          currentUser.set("Tasks", 0);
          currentUser.set("Active", true);
          _context4.prev = 26;
          _context4.next = 29;
          return currentUser.save();
        case 29:
          return _context4.abrupt("return", {
            status: "ok",
            result: true
          });
        case 32:
          _context4.prev = 32;
          _context4.t0 = _context4["catch"](26);
          console.error(_context4.t0);
          return _context4.abrupt("return", {
            status: "error",
            result: "Hubo un error al intentar guardar los datos. Inténtalo de nuevo."
          });
        case 36:
          _context4.next = 42;
          break;
        case 38:
          _context4.prev = 38;
          _context4.t1 = _context4["catch"](1);
          console.error(_context4.t1);
          return _context4.abrupt("return", {
            status: "error",
            result: "Parece que el código no es correcto. Asegúrate de introducir el correcto"
          });
        case 42:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[1, 38], [26, 32]]);
  }));
  return _verifySMSCode.apply(this, arguments);
}
export function updateTerms() {
  return _updateTerms.apply(this, arguments);
}
/**
 * Check if the Client need to update his terms.
 * @method needToUpdateTerms
 * @name Jobin.Client.needToUpdateTerms
 * @returns {boolean} Need to update his terms?
 */
function _updateTerms() {
  _updateTerms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var currentUser, currentDate;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return Parse.User.currentAsync();
        case 2:
          currentUser = _context5.sent;
          currentDate = new Date();
          currentUser.set("Terms", currentDate);
          _context5.prev = 5;
          _context5.next = 8;
          return currentUser.save();
        case 8:
          return _context5.abrupt("return", {
            status: "ok",
            result: true
          });
        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](5);
          console.error(_context5.t0);
          return _context5.abrupt("return", {
            status: "error",
            result: "Hubo un fallo inesperado al intentar aceptar los Términos y Condiciones de Jobin. Prueba de nuevo más tarde."
          });
        case 15:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[5, 11]]);
  }));
  return _updateTerms.apply(this, arguments);
}
export function needToUpdateTerms() {
  return _needToUpdateTerms.apply(this, arguments);
}
/**
 * Get the Client payments history.
 * @method getPayments
 * @name Jobin.Client.getPayments
 * @returns {Array} Payments objects array.
 */
function _needToUpdateTerms() {
  _needToUpdateTerms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var currentUser, currentTermsDate, config, termsDate, datediff;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return Parse.User.currentAsync();
        case 3:
          currentUser = _context6.sent;
          currentTermsDate = currentUser.get("Terms");
          _context6.next = 7;
          return Parse.Config.get();
        case 7:
          config = _context6.sent;
          termsDate = config.get("termsUpdate");
          datediff = Math.round((currentTermsDate - termsDate) / (1000 * 60 * 60 * 24));
          if (!(datediff < 0)) {
            _context6.next = 14;
            break;
          }
          return _context6.abrupt("return", {
            status: "ok",
            result: true
          });
        case 14:
          return _context6.abrupt("return", {
            status: "ok",
            result: false
          });
        case 15:
          _context6.next = 21;
          break;
        case 17:
          _context6.prev = 17;
          _context6.t0 = _context6["catch"](0);
          console.error(_context6.t0);
          return _context6.abrupt("return", {
            status: "error",
            result: "No hemos podido comprobar si es necesario que actualices los términos y condiciones."
          });
        case 21:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 17]]);
  }));
  return _needToUpdateTerms.apply(this, arguments);
}
export function getPayments() {
  return _getPayments.apply(this, arguments);
}
/**
 * Log out from Jobin.
 * @method logOut
 * @name Jobin.Client.logOut
 * @returns {boolean} Success.
 */
function _getPayments() {
  _getPayments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var currentUser, Transaction, query;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return Parse.User.currentAsync();
        case 2:
          currentUser = _context7.sent;
          //Search the current user Payments
          Transaction = Parse.Object.extend("Transactions");
          query = new Parse.Query(Transaction);
          query.equalTo("User", currentUser);
          query.include(["Jober.Name"]);
          query.include(["Job.Title"]);
          query.descending("createdAt");
          _context7.prev = 9;
          _context7.next = 12;
          return query.find();
        case 12:
          _context7.t0 = _context7.sent;
          return _context7.abrupt("return", {
            status: "ok",
            result: _context7.t0
          });
        case 16:
          _context7.prev = 16;
          _context7.t1 = _context7["catch"](9);
          console.error(_context7.t1);
          return _context7.abrupt("return", {
            status: "error",
            result: "Hubo un error al descargar tus pagos. Inténtalo de nuevo más tarde."
          });
        case 20:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[9, 16]]);
  }));
  return _getPayments.apply(this, arguments);
}
export function logOut() {
  return _logOut.apply(this, arguments);
}
/**
 * Delete Client account.
 * @method deleteAccount
 * @name Jobin.Client.deleteAccount
 * @returns {boolean} Success.
 */
function _logOut() {
  _logOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    var result;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return Parse.Cloud.run("deleteInstallations", null);
        case 2:
          result = _context8.sent;
          if (!result) {
            _context8.next = 9;
            break;
          }
          _context8.next = 6;
          return Parse.User.logOut();
        case 6:
          return _context8.abrupt("return", {
            status: "ok",
            result: true
          });
        case 9:
          return _context8.abrupt("return", {
            status: "error",
            result: "Hubo un error al tratar de cerrar sesión. Inténtalo de nuevo más tarde."
          });
        case 10:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _logOut.apply(this, arguments);
}
export function deleteAccount() {
  return _deleteAccount.apply(this, arguments);
}
/**
 * singIn or signUp the user with the provided params
 * @method signIn
 * @name Jobin.Client.signIn
 * @param {string} name - The user Name.
 * @param {string} phoneNumber - The user Phone Number.
 * @param {string} email - The user Email.
 * @param {boolean} fromMaster - If true, no SMS will send.
 * @returns {ParseObject} The user that matches with the phone.
 */
function _deleteAccount() {
  _deleteAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    var result;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          _context9.next = 3;
          return Parse.Cloud.run("deleteUser", null);
        case 3:
          result = _context9.sent;
          if (!result) {
            _context9.next = 8;
            break;
          }
          _context9.next = 7;
          return Parse.User.logOut();
        case 7:
          return _context9.abrupt("return", {
            status: "ok",
            result: true
          });
        case 8:
          return _context9.abrupt("return", {
            status: "error",
            result: "No pudimos eliminar tu cuenta por algún error interno. Por favor, inténtalo de nuevo más tarde."
          });
        case 11:
          _context9.prev = 11;
          _context9.t0 = _context9["catch"](0);
          console.error(_context9.t0);
          return _context9.abrupt("return", {
            status: "error",
            result: "No pudimos eliminar tu cuenta por algún error interno. Por favor, inténtalo de nuevo más tarde."
          });
        case 15:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[0, 11]]);
  }));
  return _deleteAccount.apply(this, arguments);
}
export function signIn(_x13, _x14, _x15, _x16) {
  return _signIn.apply(this, arguments);
}
/**
 * @method createBillingInfo
 * @name Jobin.Client.createBillingInfo
 * @param {string} fiscalName - Name used in fiscal issues
 * @param {string} identityNumber - User's identity number
 * @param {string} fiscalAddress  - Address used in fiscal issues
 * @param {string} fiscalPostalCode  - Postal code of the fiscal address
 * @param {string} fiscalCity  - City of the fiscal address
 * @param {string} [userId] - user to attach the info (instead of currentUser)
 * @returns {Parse.Object} - BillingInfo object
 */
function _signIn() {
  _signIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(name, phoneNumber, email, fromMaster) {
    var phone1, phone2, phone3, User, query, user, userId;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          if (!phoneNumber) {
            _context10.next = 43;
            break;
          }
          //Create the diferent phones
          phone1 = phoneNumber.substring(2, phoneNumber.lenght);
          phone2 = phoneNumber.substring(3, phoneNumber.lenght);
          phone3 = phoneNumber.substring(4, phoneNumber.lenght); //Search a user with this phone number
          User = Parse.Object.extend("_User");
          query = new Parse.Query(User);
          query.containedIn("Phone", [phone1, phone2, phone3, phoneNumber]);
          query.select("username", "Active", "Jober");
          _context10.prev = 8;
          _context10.next = 11;
          return query.first();
        case 11:
          user = _context10.sent;
          if (!user) {
            _context10.next = 24;
            break;
          }
          if (!user.get("Jober")) {
            _context10.next = 17;
            break;
          }
          return _context10.abrupt("return", {
            status: "error",
            result: "Parece que este número de teléfono ya está vinculado a una cuenta de Jobin Pro"
          });
        case 17:
          if (!user.get("Active")) {
            _context10.next = 21;
            break;
          }
          return _context10.abrupt("return", {
            status: "error",
            result: "Parece que esta cuenta está inactiva."
          });
        case 21:
          return _context10.abrupt("return", {
            status: "ok",
            result: user.id
          });
        case 22:
          _context10.next = 35;
          break;
        case 24:
          _context10.prev = 24;
          _context10.next = 27;
          return Parse.Cloud.run("createUser", {
            username: name,
            phone: phoneNumber,
            email: email,
            fromMaster: fromMaster
          });
        case 27:
          userId = _context10.sent;
          return _context10.abrupt("return", {
            status: "ok",
            result: userId
          });
        case 31:
          _context10.prev = 31;
          _context10.t0 = _context10["catch"](24);
          console.error(_context10.t0);
          return _context10.abrupt("return", {
            status: "error",
            result: _context10.t0
          });
        case 35:
          _context10.next = 41;
          break;
        case 37:
          _context10.prev = 37;
          _context10.t1 = _context10["catch"](8);
          console.error(_context10.t1);
          return _context10.abrupt("return", {
            status: "error",
            result: _context10.t1
          });
        case 41:
          _context10.next = 45;
          break;
        case 43:
          console.error("Falta parametro phoneNumber");
          return _context10.abrupt("return", {
            status: "error",
            result: "Falta parametro phoneNumber"
          });
        case 45:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[8, 37], [24, 31]]);
  }));
  return _signIn.apply(this, arguments);
}
export function createBillingInfo(_x17, _x18, _x19, _x20, _x21, _x22) {
  return _createBillingInfo.apply(this, arguments);
}
/**
 * @method getBillingInfo
 * @name Jobin.Client.getBillingInfo
 * @param {string} [userId] - user to attach the info (instead of currentUser)
 * @returns {Parse.Object} - BillingInfo object
 */
function _createBillingInfo() {
  _createBillingInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(fiscalName, identityNumber, fiscalAddress, fiscalPostalCode, fiscalCity, userId) {
    var cloudPromise;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          cloudPromise = Parse.Cloud.run("createBillingInfo", {
            fiscalName: fiscalName,
            identityNumber: identityNumber,
            fiscalAddress: fiscalAddress,
            fiscalPostalCode: fiscalPostalCode,
            fiscalCity: fiscalCity,
            userId: userId
          });
          _context11.prev = 1;
          _context11.next = 4;
          return cloudPromise;
        case 4:
          _context11.t0 = _context11.sent;
          return _context11.abrupt("return", {
            status: "ok",
            result: _context11.t0
          });
        case 8:
          _context11.prev = 8;
          _context11.t1 = _context11["catch"](1);
          console.error(_context11.t1);
          return _context11.abrupt("return", {
            status: "error",
            result: "Algo ha fallado y no hemos podido crear la información de facturación."
          });
        case 12:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[1, 8]]);
  }));
  return _createBillingInfo.apply(this, arguments);
}
export function getBillingInfo(_x23) {
  return _getBillingInfo.apply(this, arguments);
}
/**
 * logIn with email to those Users that have a Business pointer
 * @method logInBusiness
 * @name Jobin.Client.logInBusiness
 * @param {string} email - user's email
 * @param {string} password - user's password
 * @returns {Parse.Object} - User object
 */
function _getBillingInfo() {
  _getBillingInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(userId) {
    var user, billingInfo;
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;
          if (!userId) {
            _context12.next = 5;
            break;
          }
          _context12.t0 = Parse.User.createWithoutData(userId);
          _context12.next = 8;
          break;
        case 5:
          _context12.next = 7;
          return Parse.User.currentAsync();
        case 7:
          _context12.t0 = _context12.sent;
        case 8:
          user = _context12.t0;
          _context12.next = 11;
          return new Parse.Query("BillingInfo").equalTo("User", user).first();
        case 11:
          billingInfo = _context12.sent;
          return _context12.abrupt("return", {
            status: "ok",
            result: billingInfo
          });
        case 15:
          _context12.prev = 15;
          _context12.t1 = _context12["catch"](0);
          console.error(_context12.t1);
          return _context12.abrupt("return", {
            status: "error",
            result: "Algo ha fallado y no hemos podido obtener la información de facturación."
          });
        case 19:
        case "end":
          return _context12.stop();
      }
    }, _callee12, null, [[0, 15]]);
  }));
  return _getBillingInfo.apply(this, arguments);
}
export function logInBusiness(_x24, _x25) {
  return _logInBusiness.apply(this, arguments);
}
/**
 *  Search users
 * @method searchUser
 * @name Jobin.Client.searchUser
 * @param {Array} levelArray
 * @param {Date} lastConnectionStartDate
 * @param {Date} lastConnectionEndDate
 * @param {string} phone
 * @returns {Array} Array of users that match the query
 */
function _logInBusiness() {
  _logInBusiness = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(email, password) {
    var userHasBusiness, user;
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.prev = 0;
          _context13.next = 3;
          return new Parse.Query(Parse.User).equalTo("email", email).exists("Business").first();
        case 3:
          userHasBusiness = _context13.sent;
          if (!userHasBusiness) {
            _context13.next = 11;
            break;
          }
          _context13.next = 7;
          return Parse.User.logIn(email, password);
        case 7:
          user = _context13.sent;
          return _context13.abrupt("return", {
            status: "ok",
            result: user
          });
        case 11:
          return _context13.abrupt("return", {
            status: "error",
            result: "Este usuario no puede iniciar sesión en Jobin Business."
          });
        case 12:
          _context13.next = 18;
          break;
        case 14:
          _context13.prev = 14;
          _context13.t0 = _context13["catch"](0);
          console.error(_context13.t0);
          return _context13.abrupt("return", {
            status: "error",
            result: "Algo ha fallado y no hemos podido obtener la información del usuario."
          });
        case 18:
        case "end":
          return _context13.stop();
      }
    }, _callee13, null, [[0, 14]]);
  }));
  return _logInBusiness.apply(this, arguments);
}
export function search(_x26, _x27, _x28, _x29) {
  return _search.apply(this, arguments);
}
/**
 *  Search users
 * @method getById
 * @name Jobin.Client.getById
 * @param {string} userId
 * @returns {Array} Array of users that match the query
 */
function _search() {
  _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(levelArray, lastConnectionStartDate, lastConnectionEndDate, phone) {
    var query;
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          query = new Parse.Query("_User");
          query.equalTo("Jober", false);
          if (levelArray) query.containedIn("Level", levelArray);
          if (lastConnectionEndDate) query.lessThanOrEqualTo("Updated", lastConnectionEndDate);
          if (lastConnectionStartDate) query.greaterThanOrEqualTo("Updated", lastConnectionStartDate);
          if (phone) query.contains("Phone", phone);
          _context14.prev = 6;
          _context14.next = 9;
          return query.find();
        case 9:
          _context14.t0 = _context14.sent;
          return _context14.abrupt("return", {
            status: "ok",
            result: _context14.t0
          });
        case 13:
          _context14.prev = 13;
          _context14.t1 = _context14["catch"](6);
          console.error(_context14.t1);
          return _context14.abrupt("return", {
            status: "error",
            result: "Fallo al buscar usuarios"
          });
        case 17:
        case "end":
          return _context14.stop();
      }
    }, _callee14, null, [[6, 13]]);
  }));
  return _search.apply(this, arguments);
}
export function getById(_x30) {
  return _getById.apply(this, arguments);
}
function _getById() {
  _getById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(userId) {
    var query;
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          query = new Parse.Query("_User");
          query.equalTo("objectId", userId);
          _context15.prev = 2;
          _context15.next = 5;
          return query.first();
        case 5:
          _context15.t0 = _context15.sent;
          return _context15.abrupt("return", {
            status: "ok",
            result: _context15.t0
          });
        case 9:
          _context15.prev = 9;
          _context15.t1 = _context15["catch"](2);
          console.error(_context15.t1);
          return _context15.abrupt("return", {
            status: "error",
            result: "Fallo al buscar usuarios"
          });
        case 13:
        case "end":
          return _context15.stop();
      }
    }, _callee15, null, [[2, 9]]);
  }));
  return _getById.apply(this, arguments);
}